import React from "react";
import style from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { VotePaperInfo } from "API/vote";

interface SignHeaderProps {
    data: VotePaperInfo | null;
}

export default function VoteHeader({ data }: SignHeaderProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip title={data?.title} placement="bottom">
                        <span>{data?.title}</span>
                    </Tooltip>

                    <Button
                        className={style.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>

                <div className={style.info}>
                    {data?.startTime && (
                        <span>
                            开始时间{" "}
                            {moment(data?.startTime).format("MM-DD HH:mm")}
                        </span>
                    )}
                    {data?.endTime && (
                        <span>
                            ｜ 结束时间{" "}
                            {moment(data?.endTime).format("MM-DD HH:mm")}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
}
